export const allDevicesResetAltImgContainer = () => {
    var altImgContainer = $('.alt-image-list-container'),
        prevHeight = altImgContainer.height(),
        prevWidth = altImgContainer.width(),
        checkAltHeight = function() {
            var curHeight = altImgContainer.height(),
                curWidth = altImgContainer.width(),
                heightDiff = curHeight - prevHeight,
                widthDiff = curWidth - prevWidth;
            if (Math.abs(heightDiff) > 200 || Math.abs(widthDiff) > 200) {
                $('.rec-list, .alt-image-list-container ul').css({
                    'left': '0',
                    'top': '0'
                });
            }
        };
    $(window).on('resize', _.debounce(checkAltHeight, 300));
};
